import tippy from 'tippy.js';

let manager;
let time = 0;
let hostMuted = true;
let spaceBarDown = false;

let pttSpacebarEnabled = false;

function setupUI(_manager, setPTT) {
  manager = _manager;

  document.querySelectorAll('.muteMicrophone').forEach((button) => {
    button.addEventListener('click', muteMicrophone, true);
  });
  if (!setPTT) {
    hostMuted = false;
  }

  setupApollo();
  if (setPTT) {
    pttSpacebarEnabled = true;
    setupPTT();
  }
  setupTippy();
  setupOfflineListener();

  document.onkeydown = handleKeyPress;
  document.onkeyup = handleKeyUp;

  let endOfSessionButton = document.querySelector('#endOfSessionButton');
  if (endOfSessionButton) endOfSessionButton.classList.remove('hidden');

  let viewportPlaceholder = document.querySelector('#viewportPlaceholderText')
  if (viewportPlaceholder) viewportPlaceholder.classList.remove('hidden');

}

function setupOfflineListener() {
  let offlineModeBanner = document.querySelector('#offlineMode');
  if (offlineModeBanner == null) return;
  if (navigator.onLine) {
    offlineModeBanner.classList.add('hidden');
  } else {
    offlineModeBanner.classList.remove('hidden');
  }
  window.addEventListener('offline', (e) => { 
    offlineModeBanner.classList.remove('hidden');
  });
  window.addEventListener('online', (e) => {
     offlineModeBanner.classList.add('hidden');
  });
}

// @Mirror
// @Anywhere
function setupApollo() {
  window.apollo = new Audio('/audio/apollo.mp3');
}

let sessionStarted = false;
// @Mirror
// @Anywhere
function pauseAndHideApollo() {
  console.log("Pause and Hide Apollo now")
  window.apollo.pause();
  let placeholder =  document.querySelector('#viewportPlaceholderText')
  if (placeholder) placeholder.classList.add('hidden');
  else { console.log("No placeholder found"); }
}
function playApollo() {
  window.apollo.volume = 0.5;
  window.apollo.play();

  // Start the apolo meme
  window.setTimeout(() => {
    if (sessionStarted) return;
  let placeholder =  document.querySelector('#viewportPlaceholderText')
  if (placeholder) placeholder.classList.add('hidden');
  }, 5000);
}

// @ Global
function toggleModal(selector) {
  document.querySelector(selector).classList.toggle('hidden');
}

// Not used
const makeNoise = function (context, canvas) {
  const imgd = context.createImageData(canvas.width, canvas.height);
  const pix = imgd.data;

  for (let i = 0, n = pix.length; i < n; i += 4) {
    const c = 7 + Math.sin(i / 50000 + time / 7); // A sine wave of the form sin(ax + bt)
    pix[i] = pix[i + 1] = pix[i + 2] = 40 * Math.random() * c; // Set a random gray
    pix[i + 3] = 255; // 100% opaque
  }

  context.putImageData(imgd, 0, 0);
  time = (time + 1) % canvas.height;
};

// @Mirror
// @Anywhere
function unMuteAudio(enabled) {
  hostMuted = !enabled;
  manager.toggleLocalAudio(enabled);
}

// @Mirror
// @Anywhere: Guests
function handleKeyPress(ev) {
  // if its writing in any input or textarea disable this listener
  if (document.activeElement.tagName === 'INPUT') return;
  if (document.activeElement.tagName === 'TEXTAREA') return;

  if (role === 'talent') return;

  if (ev.keyCode === 32 && pttSpacebarEnabled) { // spacebar
    // do not go down when hitting spacebar
    ev.preventDefault();

    // variable to avoid repeatingly unmuting spacebar
    if (spaceBarDown) return;
    spaceBarDown = true;
    unMuteAudio(true);
  }
}
// @Mirror
// @Anywhere: Guests
function handleKeyUp(ev) {
  // Disable in Anywhere
  if (role === 'talent') return;

  if (ev.keyCode == 32 && pttSpacebarEnabled) {
    // do not go down when hitting spacebar
    if (document.activeElement.tagName === 'INPUT') return;
    if (document.activeElement.tagName === 'TEXTAREA') return;

    ev.preventDefault();
    // mute myself

    spaceBarDown = false;
    window.setTimeout(() => {
      unMuteAudio(false);
    }, 200);
  }
}

// @Mirror
// @Anywhere
function muteMicrophone(evt) {
  // // stop propagation to avoid triggering mouseup
  // evt.stopPropagation();
  if (this.dataset.id === 'microphone') {
    unMuteAudio(hostMuted);
  }
}

// @Mirror
// @Anywhere
function handleEndOfSession() {
  // TODO: this used to be a slide down before removing jquery
  let endOfSessionWrapper = document.querySelector('#endOfSession');
  if (!endOfSessionWrapper) return;
  endOfSessionWrapper.classList.remove('hidden');
  endOfSessionWrapper.classList.add('flex');
  let dcMessage = endOfSessionWrapper.querySelector(".host-disconnect-message")
  if (dcMessage) dcMessage.classList.remove("hidden");

  window.vm.$emit('session-end');
  window.sessionIsOver = true;
  // end sub
  // window.sub.consumer.disconnect();
  document.querySelector('#wellDoneMankindSound').play().catch((e) => {
    console.log(e);
  });
}

// @Mirror
// @Anywhere
function setupTippy() {
  // do not show tippy on mobile
  if (window.innerWidth < 768) return;

  tippy('[data-tippy-content]', {
    allowHTML: true,
  });
}

// @Mirror
// @Anywhere
function setupPTT() {
  const PTT_BUTTON = '.ptt';

  document.querySelectorAll(PTT_BUTTON)
  .forEach((button) => {
    button.addEventListener('mousedown', () => {
      unMuteAudio(true);
      let mouseDownDocument = (e) => {
        document.removeEventListener("mouseup", mouseDownDocument);
        unMuteAudio(false);
      }
      document.addEventListener("mouseup", mouseDownDocument);
    });

    button.addEventListener('touchstart', () => {
      unMuteAudio(true);
      document.addEventListener("touchend", () => {
        document.removeEventListener("touchend", () => {});
        unMuteAudio(false);
      });
    });

    // unmute if mouse is released outside of button
    

    // document.addEventListener("mouseup", () => {
    //   window.setTimeout(() => {
    //     unMuteAudio(false);
    //   }, 200);
    // });
    // document.addEventListener("touchup", () => {
    //   window.setTimeout(() => {
    //     unMuteAudio(false);
    //   }, 200);
    // });

  });
}

// @Mirror
// @Presenter
// handles audio UI
function updateLocalAudioUI(enabled) {
  const PTT_BUTTON = '.ptt';
  document.querySelectorAll(PTT_BUTTON).forEach((button) => {
    button.classList.toggle('speaking', enabled);
  });

  const muteButtonAll = document.querySelectorAll(".muteMicrophone[data-id='microphone']");
  muteButtonAll.forEach((muteButton) => {
    muteButton.querySelector("input").checked = enabled;
  })
}

// @Mirror
// @Presenter
function togglePTT(data) {
  if (data.message.enabled) {
    document.querySelector(`.${data.peer_key} .led`).style.height = '2rem';
  } else { // show participant not talking
    document.querySelector(`.${data.peer_key} .led`).style.height = '0rem';
  }
}
// @Mirror
function toggleCameraAudio(data) {
  if (data.message.enabled) {
    document.querySelector(`.sec_${data.peer_key} .led`).style.height = '2rem';
  } else { // show participant not talking
    document.querySelector(`.sec_${data.peer_key} .led`).style.height = '0rem';
  }
}

// This functions updates the UI from stand by state to connected state
// @Mirror
// @Anywhere
// @...ETC
// TODO: Change this to be product specific or smth
function handleUIOnRTCConnected() {
  let standBy = document.querySelector('#stand-by');
  if (standBy) standBy.classList.add('hidden');

  let standByBadge = document.querySelector('#stand-by-badge');
  if (standByBadge) standByBadge.classList.add('hidden');

  sessionStarted = true;

  const copyright = document.querySelector("#copyright");
  if (copyright) copyright.classList.add("hidden");
}

// removes stream tracks ?
function handleUIOnRTCRemovedStream(target) {
  document.querySelector(`#aux_audio_${target}`).srcObject = null;
  document.querySelector(`#audio_${target}`).srcObject = null;
  document.querySelector(`#director_to_set_${target}`).srcObject = null;
}

// Removes video bubbles from @Presenter
function handleVideoStreamRemoved(id) {
  const videoElem = document.querySelector(`[ref=${id}]`);
  if (product == 'presenter' && videoElem != null) {
    videoElem.srcObject = null;
    videoElem.parentElement.parentElement.classList.add('hidden');
  }
}

window.toggleModal = toggleModal;

export {
  handleEndOfSession, setupUI, updateLocalAudioUI, togglePTT, toggleCameraAudio, handleUIOnRTCConnected, handleUIOnRTCRemovedStream, handleVideoStreamRemoved,
  playApollo, pauseAndHideApollo,
};
